module.exports = __webpack_public_path__ + "img/career_bg.eae4c683.jpg";